module.exports = __webpack_public_path__ + "images/7-i8038f92497f22f576f099c8b8dee604d.svg";